import React, { useState, useEffect } from "react";

import { deepCloneObject, func_validation, isArrayNotEmpty, isObjectNotEmpty } from "functions";

import { useCustomSelector } from "hooks";
import useRecursiveBillingSetup from "dataflow/billingPortal/actions/useRecursiveBillingSetup.actions";
import { promiseInstance } from "dataflow/billingPortal/actions/config";
import { Toaster } from "components/notification/Toaster";

export function useSubmission(props) {
    const {
        setupInfo,
        isFormSubmissionAttempted,
    } = props;

    const [initList, setInitList] = useState([]);
    const [list, setList] = useState([]);

    const { addAccount_isSuccessful } = useCustomSelector("recursiveBillingSetup");
    const { getLicenseProducts, addAccount } = useRecursiveBillingSetup();

    useEffect(() => {
        // Get list of license products
        getLicenseProducts();
    }, []);

    useEffect(() => {
        async function checkExisitingProduct() {
            // Set existing products in billing setup
            if (setupInfo?.CompanyId && setupInfo?.AccountCode) {
                let response = await promiseInstance().get('/BillingSetup/Search?comId=' + setupInfo?.CompanyId + '&accountCode=' + setupInfo?.AccountCode + '&chargeMethod=License');

                if (isArrayNotEmpty(response?.data)) {
                    let initList = response?.data.map((obj) => {
                        return {
                            ProductCode: obj?.ProductCode,
                            ProductName: obj?.ProductName,
                            UnitPrice: obj?.UnitPrice
                        }
                    });
                    setInitList(initList);
                }
            }
        }
        checkExisitingProduct();
        
    }, []);

    // Submits
    function handleSubmission() {
        if (isArrayNotEmpty(list)) {
            list.map((obj) => {
                if (isObjectNotEmpty(obj)) {
                    let billingSetup = deepCloneObject(setupInfo);
                    billingSetup.Id = 0;
                    billingSetup.ProductCode = obj?.ProductCode;
                    billingSetup.ProductName = obj?.ProductName;
                    billingSetup.UnitPrice = obj?.UnitPrice;
    
                    addAccount(billingSetup);
                }
            })
        }
        else Toaster({
            type: "info",
            msg: "No changes made"
        })

        if (func_validation.isFunction(props.setFormSubmissionStatus))
            props.setFormSubmissionStatus(true);
    }
    function handleSuccessfulSubmission() {
        if (addAccount_isSuccessful &&
            isFormSubmissionAttempted &&
            props.updateParentState_visiblity)
            props.updateParentState_visiblity(false);
    }
    useEffect(() => {
        handleSuccessfulSubmission();
    }, [addAccount_isSuccessful]);

    return {
        handleSubmission, list, setList, initList
    }
}